import { QueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'

export const invalidateReconciliationQueries = (queryClient: QueryClient): Promise<void> => {
  return Promise.all([
    queryClient.invalidateQueries(QueryKeys.BankLines),
    queryClient.invalidateQueries(QueryKeys.Invoices),
    queryClient.invalidateQueries(QueryKeys.Bills),
    queryClient.invalidateQueries(QueryKeys.Postings),
    queryClient.invalidateQueries(QueryKeys.ExternalInvoices),
    queryClient.invalidateQueries(QueryKeys.BankLineSuggestions),
    queryClient.invalidateQueries(QueryKeys.BankLineMatchAssociations),
    queryClient.invalidateQueries(QueryKeys.BankLineMatchedItems),
    queryClient.invalidateQueries(QueryKeys.DaybookTransaction),
  ]).then(() => undefined)
}
